<template>
    <div class="sms-container">
        <sp-input
            v-model="sms"
            class="sms-container-input"
            placeholder="请输入验证码"
            :maxlength="6"
            :autofocus="true"
            :clearable="true"
            @input="onInput"
        >
            <template #suffix>
                <div
                    :class="isCounting ? 'counting' : ''"
                    @click="onGetSms"
                >
                    {{ !isCounting ? btnDesc : `${countDown}s` }}
                </div>
            </template>
        </sp-input>
    </div>
</template>

<script>
import { Input } from '@ks/sharp-ui';
import { postSendSms } from '@/utils/fetch';
import { toast } from '@/utils/toast';

export default {
    name: 'send-sms',
    components: {
        [Input.name]: Input,
    },
    data() {
        return {
            sms: '', // 短信验证码
            isCounting: false, // 已发送短信验证码
            countDown: 60, // 剩余秒数
            timer: null, // 
            btnDesc: '获取验证码', // 发送验证码-文案
        };
    },
    methods: {
        startCountDown() {
            if (this.timer) {return;}
            if (!this.isCounting) {
                this.isCounting = true;
                this.timer = setInterval(() => {
                    if (this.countDown <= 0) {
                        this.resetBtnDesc();
                        this.resetCountDown();
                    } else {
                        this.countDown -= 1;
                    }
                }, 1000);
            }
        },
        async onGetSms() {
            await this.$emit('emit-on-click-send-sms', this.sms);
            this.startCountDown();
        },
        onInput(val) {
            this.$emit('emit-on-input-sms', val);
        },
        resetBtnDesc() {
            this.btnDesc = '重新获取';
        },
        resetCountDown() {
            clearInterval(this.timer);
            this.timer = null;
            this.isCounting = false;
            this.countDown = 60;
        },
    },
    beforeDestroy() {
        this.resetCountDown();
    },
};
</script>
<style lang='less' scoped>
.sms-container {
    display: flex;
    flex-direction: column;

    /deep/ .sp-input {
        &::after {
            border: transparent;
            font-size: 14px;
        }
    }

    /deep/ .sp-input__suffix {
        margin-right: 12px;
        color: #FE3666;
        font-size: 16px;
    }

    /deep/ .sp-input__field {
        padding: 8px 12px;
        font-size: 16px;
    }


    &-input {
        background-color: #F8F8F8;
        margin-top: 24px;
        border-radius: 8px;
        overflow: hidden;
        height: 46px;
    }
}

.counting {
    color: #9C9C9C;
    cursor: not-allowed;
}
</style>
